export enum TriggerMetricEnum {
    DailyProfits = "daily-profits",
    DailySales = "daily-sales",
    DailySalesExvat = "daily-sales-exvat",
    DailyOrders = "daily-orders",
}
